import { render, staticRenderFns } from "./approveAffiliate.vue?vue&type=template&id=6fe20384&lang=pug"
import script from "./approveAffiliate.vue?vue&type=script&lang=js"
export * from "./approveAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports